/**
 * @generated SignedSource<<1d12c608260b47173be6af6f550d02e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetAgendaSidebar_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "TeeSheetAgendaSidebar_session";
};
export type TeeSheetAgendaSidebar_session$key = {
  readonly " $data"?: TeeSheetAgendaSidebar_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaSidebar_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetAgendaSidebar_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "750004405530adc7f2e64d17858f6ce6";

export default node;
